import React, { useEffect, useState,useRef} from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Axios from "axios";
import { GetCourseInfo, GetScheduledCandidatebyid } from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import LoadingSpinner from "../helpers/loadingspinner";
import Modal from 'react-bootstrap/Modal';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactPlayer from 'react-player';
import parse from "html-react-parser"
import DOMPurify from 'dompurify';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewDeletedVideoCandidateDetails = () => {
    let query = useQuery();
    const GuiID = query.get("guid");

    const [candidateDetails, setCandidateDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [jobRoles, setJobRoles] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });
    const [showVideoModal, setShowVideoModal] = useState(false);
    const videoRef = useRef(null); // Add ref for the video element
    const [rating, setRating] = useState([
      { ratingID: "1", ratingName: "1 - Not-Considerable" },
      { ratingID: "2", ratingName: "2 - Average Candidate" },
      { ratingID: "3", ratingName: "3 - Considerable Candidate" },
      { ratingID: "4", ratingName: "4 - Preferable Candidate" },
      { ratingID: "5", ratingName: "5 - Expert Candidate" },
  ]);
  const [playedSeconds, setPlayedSeconds] = useState(0); // State to track played time
  const playerRef = useRef(null);
  
  const getRatingName = (ratingID) => {
    const ratingItem = rating.find(r => r.ratingID == ratingID);
    return ratingItem ? ratingItem.ratingName : "Unknown Rating";
  }
  
    const GetCandidateDetails = () => {
        const GetapiUrl = `${GetScheduledCandidatebyid.APIURL}/${GuiID}`;
        Axios.get(GetapiUrl,{ headers: { Authorization: `Bearer ${localStorage.getItem("jwtToken")}` } })
            .then((result) => {
                setCandidateDetails(result.data[0]);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching candidate details:", error);
                setIsLoading(false);
            });
    };
    const fetchQualifications = async () => {
      const getApiUrl = GetCourseInfo.APIURL;
      try {
          const response = await Axios.get(getApiUrl);
          setQualifications(response.data);
      } catch (error) {
          console.error("Error fetching qualifications", error);
      }
  };
  
  const getExperienceText = (experience) => {
    if (!experience) return '';
    return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
  };
const getQualificationName = (id) => {
  const qualification = qualifications.find(q => q.qualificationID == id);
  return qualification ? qualification.courseName : "";
};
const handleCloseModal = () => {
  setShowModal(false);
};

const handleVideoClick = (videoURL) => {
  setCurrentVideoUrl(videoURL);
  setShowVideoModal(true);
};
const handleShowModal = (title, url) => {
  setModalContent({ title, url });
  setShowModal(true);
};

const handleClose = () => {
  setShowVideoModal(false);
  setCurrentVideoUrl('');
};
    const renderAttachment = (fileUrl) => {
      if (fileUrl) {
          const fileExtension = fileUrl.split('.').pop().toLowerCase();
          if (fileExtension === 'pdf') {
              return (
                  <iframe src={fileUrl} title="Attachment" style={{ width: '100%', height: '500px' }} />
              );
          } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
              return (
                  <img src={fileUrl} alt="Attachment" style={{ width: '100%' }} />
              );
          } else if (fileExtension === 'docx') {
              return (
                  <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`} title="Attachment" style={{ width: '100%', height: '500px' }} />
              );
          } else {
              return (
                  <a href={fileUrl} target="_blank" rel="noopener noreferrer">Download Attachment</a>
              );
          }
      }
      return <p>No attachment available</p>;
  };
  const handleProgress = (state) => {
    if (state.playedSeconds !== playedSeconds) {
      setPlayedSeconds(state.playedSeconds);
    }
  };

  const handleForward = () => {
    if (videoRef.current) {
      videoRef.current.currentTime += 10; // Forward by 10 seconds
    }
  };

  const handleRewind = () => {
    if (videoRef.current) {
      videoRef.current.currentTime -= 10; // Rewind by 10 seconds
    }
  };

  const handleDownload = () => {
    // You can implement download logic here
    // Example: Redirecting to the video URL to trigger download
    if (currentVideoUrl) {
      window.location.href = currentVideoUrl;
    }
  };
    useEffect(() => {
        GetCandidateDetails();
        fetchQualifications();
    }, []);

    return (
        <ConsultantLayout>
            {isLoading ? (
                <center><LoadingSpinner /></center>
            ) : (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListOfDeletedVideos">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>View Candidate Details</h2>
</div>                    <hr/>
                    {candidateDetails && (
                        <>
                         <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
                        <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                    
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-name">Name</Tooltip>}>
                                <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.name}</p>
                            </OverlayTrigger>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                                <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                            </OverlayTrigger>

                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Mobile Number</Tooltip>}>
                                <p className="text-para"><i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                            </OverlayTrigger>

                            {candidateDetails.address!==null && candidateDetails.address!=='null' &&  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Address</Tooltip>}>
                                <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                            </OverlayTrigger>}
                            {candidateDetails.experience!==null && candidateDetails.experience!=='null'&&  ( 
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Experience</Tooltip>}>
                                <p className="text-para"><i className="fa fa-user-tie icons"></i> {getExperienceText(candidateDetails.experience)}</p>
                            </OverlayTrigger>)}

                            {candidateDetails.jobRole!==null && candidateDetails.jobRole!=='null' &&candidateDetails.jobRole!==0 &&   ( 
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Job Role</Tooltip>}>
                                <p className="text-para"><i className="fa fa-briefcase icons"></i>  {(candidateDetails.jobRole)}</p>
                            </OverlayTrigger>)}

                            {candidateDetails.workMode!==null && candidateDetails.workMode!=='null' &&candidateDetails.workMode!==0 &&   ( 
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-startDate">Work Mode </Tooltip>}>
                                <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.workMode}</p>
                            </OverlayTrigger>)}
{/* 
                            {candidateDetails.comments!==null && candidateDetails.comments!=='null'&& <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-endDate">Comments</Tooltip>}>
                                <p className="text-para"><i className="fa fa-comment icons"></i> {parse(candidateDetails.comments)}</p>
                            </OverlayTrigger>} */}

{candidateDetails.comments !== null && candidateDetails.comments !== 'null' && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-endDate">Comments</Tooltip>}
        >
          <div className="commenttt-wrapper ">
            <i className="fa fa-comment icons mt-2 mr-2"></i>
            <p  className="text-paraaa">{parse(DOMPurify.sanitize(candidateDetails.comments))}</p>
          </div>
        </OverlayTrigger>
      )}

                            {candidateDetails.rating!==null && candidateDetails.rating!=='null' && (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-rating">Rating</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-star icons"></i> {getRatingName(candidateDetails.rating)}</p>
                                </OverlayTrigger>

                            )}
                              </div>
                            <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                            {candidateDetails.qualificationID!==null && candidateDetails.qualificationID!=='null' &&candidateDetails.qualificationID!==0 &&   ( 
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Qualification</Tooltip>}>
                                <p className="text-para"><i className="fa fa-graduation-cap icons"></i>  {getQualificationName(candidateDetails.qualificationID)}</p>
                            </OverlayTrigger>)}

                            {candidateDetails.dob!==null && candidateDetails.dob!=='null' &&  (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Date of Birth</Tooltip>}>
                                    <p className="text-para">
                                        <i className="fa fa-birthday-cake icons"></i> {candidateDetails.dob}</p>
                                </OverlayTrigger>
                            )}

                                {candidateDetails.gender!==null && candidateDetails.gender!=='null' && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Gender</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-venus-mars icons"></i> {candidateDetails.gender}</p>
                                </OverlayTrigger>
                            )}

                  {candidateDetails.passportNo!==null && candidateDetails.passportNo!=='null' && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Passport Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-book icons"></i> {candidateDetails.passportNo}</p>
                                </OverlayTrigger>
                            )}
                            
                            {candidateDetails.workAuthorizationandValidity!==null && candidateDetails.workAuthorizationandValidity!=='null' && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Work Authorization and Validity</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-comment icons"></i> {candidateDetails.workAuthorizationandValidity}</p>
                                </OverlayTrigger>
                            )}

{candidateDetails.linkedInUrl !== null && candidateDetails.linkedInUrl !== "null" && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">LinkedIn Url</Tooltip>}>
        <a 
            href={candidateDetails.linkedInUrl?.startsWith('http') ? candidateDetails.linkedInUrl : `https://${candidateDetails.linkedInUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para">
                <i className="fa fa-graduation-cap icons mr-1"></i>
                {candidateDetails.linkedInUrl}
            </p>
        </a>
    </OverlayTrigger>
)}
                                               
                           
                              {/* {candidateDetails.videoURL!==null && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Video URL</Tooltip>}>
                              <p className="text-para"><i className="fa fa-video icons"></i> <a href="#!" style={{fontSize:18}} onClick={() => handleVideoClick(candidateDetails.videoURL)}>View Video</a></p>
                                </OverlayTrigger>
                            )} */}
                                {candidateDetails.resume!==null && candidateDetails.resume!=='null' &&  (
                             <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
                                    <p className="text-para">
                                    <a 
            href="#" 
            style={{ fontSize: 18 }} 
            onClick={() => handleShowModal('Resume', candidateDetails.fileUrl)}
          >
            <i className="fa fa-file-alt icons"></i> View Resume
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.fileUrl} 
            style={{ fontSize: 18 }} 
            download
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Resume
          </a>                                        </p>
                                </OverlayTrigger>)}

                           
            {candidateDetails.visaCopy!==null && candidateDetails.visaCopy!=='null' &&  
             <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-visaCopy">Proof of Residence</Tooltip>}>

                                    <p className="text-para">
                                    <a 
            href="#" 
            style={{ fontSize: 18 }} 
            onClick={() => handleShowModal('Visa Copy', candidateDetails.visaCopyUrl)}
          >
            <i className="fa fa-id-card icons"></i> View Proof of Residence
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.visaCopyUrl} 
            style={{ fontSize: 18 }} 
            download
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Proof of Residence
          </a>                                        </p>
                                </OverlayTrigger>}
                                {candidateDetails.drivingLicence!==null && candidateDetails.drivingLicence!=='null' &&  
                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-drivingLicence">Government Issued ID</Tooltip>}>
                                    <p className="text-para">
                                    <a 
            href="#" 
            style={{ fontSize: 18 }} 
           
            onClick={() => handleShowModal('Driving Licence', candidateDetails.drivingLicenceUrl)}
          >
            <i className="fa fa-car icons"></i> View Government Issued ID
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.drivingLicenceUrl} 
            style={{ fontSize: 18 }} 
            download
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Government Issued ID
          </a>                                        </p>
                                </OverlayTrigger>}
                                </div>
                               

                               
                              
                      </div>
</div>
                        </>
                    )}
                </div> 
            )}
            
      

            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
        </ConsultantLayout>
    );
};

export default ViewDeletedVideoCandidateDetails;
